/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Testimonials data
  ============================================================

  Demo-palautteet vaihdetaan myöhemmin asiakkaan oikeisiin
  palautteisiin.

  Rakenne voidaan myöhemmin korvata WordPress REST API -datalla.
*/

const testimonialsData = {
  enabled: true,

  section: {
    eyebrow: {
      fi: "Asiakkaiden sanoin",
      en: "Kind words",
    },

    title: {
      fi:
        "Kuvat jäävät elämään siellä, missä tarina jatkuu.",

      en:
        "Photographs live on where the story continues.",
    },

    description: {
      fi:
        "Kuvaustilanne kestää hetken. Valmiit kuvat kulkevat mukana paljon pidempään.",

      en:
        "A session lasts for a moment. The photographs stay with you much longer.",
    },

    swipe: {
      fi: "Pyyhkäise",
      en: "Swipe",
    },
  },

  items: [
    {
      id: "01",
      enabled: true,
      order: 10,

      name:
        "Aino & Elias",

      type: {
        fi: "Hääkuvaus",
        en: "Wedding photography",
      },

      quote: {
        fi:
          "Kuvauspäivä tuntui alusta asti helpolta. Meidän ei tarvinnut miettiä, mitä kameran edessä pitäisi tehdä — saimme vain olla yhdessä. Kuvissa on juuri se tunnelma, jonka halusimme muistaa.",

        en:
          "From the beginning, being photographed felt easy. We never had to think about what to do in front of the camera — we could simply be together. The photographs hold exactly the feeling we wanted to remember.",
      },
    },

    {
      id: "02",
      enabled: true,
      order: 20,

      name:
        "Sofia",

      type: {
        fi: "Henkilökuvaus",
        en: "Portrait session",
      },

      quote: {
        fi:
          "En yleensä viihdy kameran edessä, mutta tällä kertaa unohdin sen hyvin nopeasti. Lopputulos tuntuu minulta eikä joltain roolilta, jota yritin esittää.",

        en:
          "I normally feel uncomfortable in front of a camera, but this time I forgot about it very quickly. The result feels like me rather than a role I was trying to perform.",
      },
    },

    {
      id: "03",
      enabled: true,
      order: 30,

      name:
        "Studio North",

      type: {
        fi: "Yritys- ja brändikuvaus",
        en: "Business and brand photography",
      },

      quote: {
        fi:
          "Kuvat näyttävät vihdoin samalta kuin yrityksemme tuntuu. Saimme yhdellä kuvauksella materiaalin verkkosivuille, someen ja markkinointiin ilman että kokonaisuus näyttää geneeriseltä.",

        en:
          "The photographs finally look the way our business feels. One session gave us material for our website, social media and marketing without the result feeling generic.",
      },
    },
  ],
};

export default testimonialsData;